module.exports = __webpack_public_path__ + "static/media/Preeti M.864705a0.jpg";